export const emptyEntryPoint = {
  id: null,
  name: "",
  url: ""
};
